import { rest } from "src/common/rest";
import { apiAuditServiceUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import { zEntity, ZEntity } from "src/types/ZEntity";
import {
  AuditSearchFilter,
  zPageAuditEvent,
  ZPageAuditEvent,
} from "./ZEntityAudit";

/**
 * @see http://plm-qa-01.d4r.int/gateway-service/services/audit-service/swagger-ui/index.html#/
 */

export const loadAudit = async (
  filter: AuditSearchFilter,
): Promise<ZPageAuditEvent> => {
  const resp = await rest.post(apiAuditServiceUrl("/audit"), filter);
  return zPageAuditEvent.parse(resp.data);
};

export const loadEntityAudit = async (
  entityId: ZUid,
  transactionId: string,
): Promise<ZEntity> => {
  const resp = await rest.get(apiAuditServiceUrl("/audit"), {
    params: { entityId, transactionId },
  });
  return zEntity.parse(resp.data);
};
